import axios from 'axios'

export default {
  namespaced: true,
  state: {
    wechats: sessionStorage.getItem('wechatstore_wechats') ? JSON.parse(sessionStorage.getItem('wechatstore_wechats')) : false
  },
  mutations: {
    fetch (state, wechats) {
      state.wechats = wechats
      sessionStorage.setItem('wechatstore_wechats', JSON.stringify(wechats))
    }
  },
  actions: {
    roles ({ commit }, roles) {
      commit('roles', roles)
    },
    async fetch ({ commit }, site) {
      const res = await axios(`/web/user/wechat/${site}/`)
      commit('fetch', await res.data)
    }
  },
  getters: {
    wechats: (state) => {
      return state.wechats || []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/WechatStore.js